<template>
  <div class="container">
    <h2>Gestion des individus</h2>
    <hr>
    <div class="form-row">
      <div class="form-group col-sm-3">
        <kez-input :label="'Prénom'" v-model="worker.firstName" validate="required"/>
      </div>
      <div class="form-group col-sm-3">
        <kez-input :label="'Nom'" v-model="worker.lastName" validate="required"/>
      </div>
      <div class="form-group col-sm-4">
        <div class="addBtn">
          <button
            v-if="isAdd"
            type="submit"
            class="btn btn-action btn-md"
            @click="add(worker)"
          >Ajouter</button>
          <button
            v-if="!isAdd"
            type="submit"
            class="btn btn-action btn-md"
            @click="completeEdit()"
          >Modifier</button>
          <button v-if="!isAdd" type="submit" class="btn btn-action btn-md" @click="cancel()">Cancel</button>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="search-wrapper form-group col-sm-8 headerTask">
        <h3>Liste des individus</h3>
      </div>
      <!-- SEARCH -->
      <div class="search-wrapper form-group col-sm-4 headerTask">
        <input type="search" v-model="search" placeholder="Nom de l'individu">
        <button type="submit" class="btn btn-action btn-sm" v-on:click="resetFields()">
          <i class="material-icons">cancel</i>
        </button>
      </div>
    </div>
    <!-- -->
    <table class="table table-striped mt-1">
      <thead>
        <tr>
          <th>Prénom</th>
          <th>Nom</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(worker,index) in filteredList" :key="index" v-show="worker.isActive==true">
          <td>{{ worker.firstName }}</td>
          <td>{{ worker.lastName }}</td>
          <td>
            <button type="submit" class="btn btn-action btn-sm" @click="edit(worker.workerGuid)">
              <i class="material-icons">edit</i>
            </button>
            <button type="submit" class="btn btn-action btn-sm" @click="remove(worker.workerGuid)">
              <i class="material-icons">delete</i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <kez-confirm-modal
      v-model="openModalDelete"
      :title="'Supprimer un individu'"
      :message="'Êtes-vous sur de vouloir supprimer cet individu?'"
      @confirm="deleteWorker()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import KezInput from "@/components/_forms/KezInput";
import KezConfirmModal from "@/components/_modals/KezConfirmModal";
import Search from "@/components/search/Search";

export default {
  components: {
    KezInput,
    KezConfirmModal,
    Search
  },
  data() {
    return {
      isAdd: true,
      openModalDelete: false,
      isEdit: false,
      selectedWorker: null,
      search: ""
    };
  },
  computed: {
    filteredList() {
      return this.workers.filter(worker => {
        if (
          worker.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
          worker.lastName.toLowerCase().includes(this.search.toLowerCase())
        )
          return worker;
      });
    },
    ...mapState("workers", ["workers", "worker"])
  },
  mounted() {
    this.$store.commit("workers/worker", {});
    this.$store.dispatch("workers/getList");
    this.$store.dispatch("workers/getAllList");
    this.$store.dispatch("workers/getActiveList");
  },
  methods: {
    add(worker) {
      this.isEdit = true;
      const newWorker = worker;
      if (this.worker.firstName != null && this.worker.lastName != null) {
        this.$store.dispatch("workers/save", { worker: newWorker });
        this.worker = {};
      }
    },
    deleteWorker() {
      this.$store.dispatch("workers/delete", this.selectedWorker);
    },
    remove(worker) {
      this.selectedWorker = worker;
      this.openModalDelete = true;
    },
    edit(worker) {
      this.$store.dispatch("workers/get", worker);
      this.isAdd = false;
    },
    cancel() {
      this.$store.commit("workers/worker", {});
      this.isAdd = true;
    },
    completeEdit() {
      this.$store.dispatch("workers/save", { worker: this.worker });
      this.isAdd = true;
    },
    resetFields() {
      this.search = "";
    }
  }
};
</script>

<style>
.addBtn {
  margin-top: 38px;
}
</style>
